import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// 导入语言包
import zhCN from "../locales/zh-CN/common.json";
import enUS from "../locales/en-US/common.json";

const resources = {
  "zh-CN": {
    translation: zhCN,
  },
  "en-US": {
    translation: enUS,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "zh-CN", // 默认语言
    debug: process.env.NODE_ENV === "development",

    interpolation: {
      escapeValue: false, // React 已经做了 XSS 防护
    },

    detection: {
      // 语言检测顺序
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },
  });

export default i18n;
